export function sortAlphabetically<T>(sortProperty: string, array: T[]): T[] {
  return array.sort((a, b) => b[sortProperty].localeCompare(a[sortProperty]));
}
